import { GQButton } from '../GQButton';
import React from 'react';
import cx from 'classnames';

export interface ISidebarRiskPickerAbstractContentProps {
    onItemClick: (itemId: number) => void;
    selectedItemsIds: number[];
    headerTab?: {
        name?: string;
        iconName?: string;
    };
}

interface ISidebarRiskPickerWrapperProps {
    title?: string;
    initialSelectedTabIndex?: number;
    onTabChange?: (tabIndex: number) => void;
    children:
        | Array<React.ReactElement<ISidebarRiskPickerAbstractContentProps>>
        | React.ReactElement<ISidebarRiskPickerAbstractContentProps>;
}

interface ISidebarRiskPickerWrapperState {
    isMinimized: boolean;
    selectedTabIndex: number;
}

//todo: delete this file and all old risk picker files
export default class SidebarRiskPickerWrapper extends React.Component<
    ISidebarRiskPickerWrapperProps,
    ISidebarRiskPickerWrapperState
> {
    constructor(props: ISidebarRiskPickerWrapperProps) {
        super(props);
        this.state = {
            isMinimized: false,
            selectedTabIndex: null,
        };
    }

    public render() {
        const tabs = React.Children.toArray(this.props.children);
        const selectedTabContent = tabs[this.selectedTabIndex];
        return (
            <div
                id="sidebar-risk-picker-wrapper"
                className={cx({
                    minimized: this.state.isMinimized,
                })}>
                <div id="sidebar-risk-picker-wrapper-header">
                    <span className="sidebar-risk-picker-wrapper-header-content">
                        <div className="header-tabs">
                            {tabs.length > 1 &&
                                tabs.map(
                                    //@ts-ignore
                                    (
                                        tab: React.ReactElement<
                                            ISidebarRiskPickerAbstractContentProps
                                        >,
                                        i
                                    ) => {
                                        const headerTabProps = {
                                            iconName: 'gqi-indicators',
                                            name: undefined,
                                            ...tab.props.headerTab,
                                        };

                                        return (
                                            <GQButton
                                                key={`sidebar-risk-picker-header-tab-${i}`}
                                                toggleButton={true}
                                                noBorder={true}
                                                onClick={this.onTabChange.bind(
                                                    this,
                                                    i
                                                )}
                                                active={
                                                    this.selectedTabIndex === i
                                                }
                                                tooltip={headerTabProps.name}
                                                tooltipPosition="bottom left">
                                                {headerTabProps.name}
                                            </GQButton>
                                        );
                                    }
                                )}
                        </div>
                    </span>
                </div>

                <div id="sidebar-risk-picker-content">{selectedTabContent}</div>
            </div>
        );
    }

    private get selectedTabIndex(): number {
        const numTabs = React.Children.count(this.props.children);
        if (this.state.selectedTabIndex != null) {
            return this.state.selectedTabIndex;
        } else if (
            this.props.initialSelectedTabIndex != null &&
            this.props.initialSelectedTabIndex < numTabs
        ) {
            return this.props.initialSelectedTabIndex;
        } else {
            return 0;
        }
    }

    private onTabChange = (tabIndex: number) => {
        if (this.state.selectedTabIndex !== tabIndex) {
            this.setState({
                selectedTabIndex: tabIndex,
            });

            if (this.props.onTabChange) {
                this.props.onTabChange(tabIndex);
            }
        }
    };
}
